/**
 * AddEventListenerOptions for listeners that may prevent the browser scroll.
 *
 * @since 3.4.1
 */
export const SCROLL_LISTENER_OPTIONS = { passive: false, capture: true };
